import { connect } from "react-redux";
import { EndSimulation as Component } from "./EndSimulation";
import { showModal } from "@learningblocks/exp-redux";

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data));
    },
  };
}

export const EndSimulation = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
